<template>
  <div class="pba-control" :class="{ 'pba-control--saving': saving }" :aria-busy="saving">
    <span class="pba-title">Partecipato</span>
    <div class="pba-options" role="group" :aria-label="`Partecipato: ${booking.fullName || booking.email || 'prenotazione'}`">
      <button type="button" :aria-pressed="selectedValue === true" :title="selectedValue === true ? 'Annulla la presenza e torna a Da verificare' : 'Segna come presente'" :disabled="disabled || saving" @click="toggle(true)">Sì</button>
      <button type="button" :aria-pressed="selectedValue === false" :title="selectedValue === false ? 'Annulla l’assenza e torna a Da verificare' : 'Segna come assente'" :disabled="disabled || saving" @click="toggle(false)">No</button>
    </div>
    <small v-if="saving" class="pba-saving" role="status"><span class="pba-spinner" aria-hidden="true"></span>Salvataggio…</small>
    <small v-else-if="booking.participated == null">Da verificare</small>
    <small v-else>{{ booking.participated ? 'Presenza registrata' : 'Assenza registrata' }}</small>
    <small v-if="error" class="pba-error" role="alert">{{ error }}</small>
  </div>
</template>

<script>
export default {
  name: 'PublicBookingAttendance',
  props: {
    booking: { type: Object, required: true },
    saving: { type: Boolean, default: false },
    pendingValue: { default: undefined, validator: value => value == null || typeof value === 'boolean' },
    disabled: { type: Boolean, default: false },
    error: { type: String, default: '' },
  },
  emits: ['change'],
  computed: {
    selectedValue() {
      return this.saving && this.pendingValue !== undefined
        ? this.pendingValue : this.booking.participated;
    },
  },
  methods: {
    toggle(value) {
      if (this.disabled || this.saving) return;
      this.$emit('change', this.selectedValue === value ? null : value);
    },
  },
};
</script>

<style scoped>
.pba-control { display:flex; flex-direction:column; align-items:flex-start; gap:6px; min-width:120px; }
.pba-title { font-size:12px; font-weight:600; color:#475569; }
.pba-options { display:inline-flex; padding:3px; gap:3px; border:1px solid #d5dce1; background:#f3f5f6; border-radius:10px; }
.pba-options button { appearance:none; display:inline-flex; align-items:center; justify-content:center; min-width:46px; min-height:38px; margin:0; padding:8px 12px; border:1px solid transparent; border-radius:7px; background:transparent; color:#526070; box-shadow:none; font:inherit; font-size:14px; font-weight:600; cursor:pointer; }
.pba-options button[aria-pressed="true"] { background:#fff; border-color:#a8b6c5; color:#18293b; box-shadow:0 1px 3px #152a4012; }
.pba-options button:first-child[aria-pressed="true"] { background:#e6f4eb; border-color:#79b58d; color:#21603a; }
.pba-options button:focus-visible { outline:2px solid #3567a2; outline-offset:2px; }
.pba-options button:disabled { cursor:wait; opacity:.55; }
.pba-control--saving .pba-options button[aria-pressed="true"] { opacity:1; }
.pba-saving { display:flex; align-items:center; gap:5px; }
.pba-spinner { box-sizing:border-box; width:11px; height:11px; border:2px solid #c9d7cf; border-top-color:#377d60; border-radius:50%; animation:pba-spin .7s linear infinite; }
@keyframes pba-spin { to { transform:rotate(360deg); } }
@media (prefers-reduced-motion:reduce) { .pba-spinner { animation:none; } }
.pba-control small { font-size:11px; color:#667584; line-height:1.4; }
.pba-control .pba-error { max-width:240px; color:#a52f35; }
@media (max-width:768px) { .pba-options button { min-height:44px; min-width:54px; } }
</style>
